<!--
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2023-09-01 13:56:56
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2023-12-07 16:01:46
 * @FilePath: /platform/src/views/system/noticeRules/formFieldSelector.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-popover placement="bottom" width="200" trigger="click">
      <template v-if="this.deumKey">
        <div style="cursor: pointer; line-height: 22px" v-for="(item, index) in treeData" :key="index" @click="handleNodeClick(item)">
          {{ item.label }}
        </div>
      </template>
      <template v-else>
        <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </template>
      <el-link type="primary" :underline="false" slot="reference" style="margin-left: 10px">选择变量</el-link>
    </el-popover>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import utils from '@/utils'
export default {
  props: ['boKey', 'deumKey'],
  data() {
    return {
      treeData: [],
      defaultProps: {
        label: 'variable_name',
        children: 'children'
      },
      filterText: ''
    }
  },
  computed: {
    ...mapState({
      allEnumerate: (state) => state.user.allEnumerate
    })
  },
  watch: {
    boKey: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$http.get('${risk}/rule/business_reminder/getVariableByModuleKey?key=' + newVal).then((res) => {
            if (res.data) {
              this.treeData = res.data
              // console.log(this.treeData, 5555);
            }
          })
        }
      }
    }
  },
  mounted() {
    let that = this
    if (that.deumKey) {
      that.defaultProps = {
        label: 'label',
        children: 'children'
      }
      that.$nextTick(() => {
        that.treeData = utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: that.deumKey,
          allData: that.allEnumerate
        })
      })
    }
  },
  methods: {
    handleNodeClick(val) {
      this.$emit('setField', val)
    }
  }
}
</script>
